export const formatTaxId = (taxId: string) => {
  const digits = taxId.replace(/\D/g, '');

  if (digits.length === 11) {
    // CPF
    return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  } else if (digits.length === 9) {
    // SSN
    return digits.replace(/(\d{3})(\d{2})(\d{4})/, '$1-$2-$3');
  } else {
    return taxId; // formato desconhecido, retorna como está
  }
}
